module.exports = __webpack_public_path__ + "static/media/Skrill.e777f7d8.png";